import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getCustomerDetails, getCustomers, GetCustomersParams } from '../clients/company.api';
import { getCustomerSettings } from '../clients/companySettings.api';

export const customers = createQueryKeys('customers', {
    list: (params: GetCustomersParams = {}) => ({
        queryKey: [{ params }],
        queryFn: () => getCustomers(params),
    }),
    comboBoxOptions: (params: GetCustomersParams) => ({
        queryKey: [{ params }],
    }),
    selectedComboBoxOption: (customerId: string) => ({
        queryKey: [customerId],
    }),
    detail: (customerId: string) => ({
        queryKey: [customerId],
        queryFn: () => getCustomerDetails(customerId),
        contextQueries: {
            settings: {
                queryKey: null,
                queryFn: () => getCustomerSettings(customerId),
            },
        },
    }),
    settings: (customerIds: string[]) => ({
        queryKey: [{ customerIds }],
    }),
});
